import React, { useEffect, useState, memo } from "react";
import Chart from "react-apexcharts";
import Spinner from "@atlaskit/spinner";
import useFetch from "../../../../hooks/use-fetch";
import styles from "./JobSummary.module.css";

const JobSummary = ({ appType }) => {
  const [series, setSeries] = useState([]);
  const [options, setOptions] = useState({});
  const url = `api/dashboard/widget/jobs/summary-stats?jobType=${appType}`;
  const { data: jobSummary, isLoading, error: errorMessage } = useFetch(url);
  const { totalCount, totalPercentage, status } = { ...jobSummary };

  useEffect(() => {
    if (status) {
      setSeries([status.success, status.partialSuccess, status.error]);
      setOptions({
        chart: {
          type: "donut",
          width: "100%",
          animations: {
            enabled: true,
            easing: "easeinout",
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150,
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350,
            },
          },
        },
        title: {
          text: "Jobs summary",
          align: "left",
          offsetX: 15,
          floating: false,
          style: {
            fontSize: "20px",
            fontWeight: 500,
            fontFamily: [
              "Segoe UI",
              "Roboto",
              "Oxygen",
              "Ubuntu",
              "Cantarell",
              "Fira Sans",
              "Droid Sans",
              "Helvetica Neue",
            ],
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: true,
          offsetY: 0,
          position: "bottom",
          horizontalAlign: "left",
          floating: true,
          formatter: function (val, opts) {
            return val + " - " + opts.w.globals.series[opts.seriesIndex];
          },
          onItemClick: {
            toggleDataSeries: false,
          },
        },
        labels: ["Successful", "Partially successful", "Failed"],
        colors: ["#36B37E", "#FFAB00", "#FF5630"],
        plotOptions: {
          pie: {
            customScale: 0.7,
            expandOnClick: true,
            donut: {
              size: "55%",
              labels: {
                show: true,
                total: {
                  show: true,
                  showAlways: true,
                  fontSize: totalCount === 0 ? "20px" : "40px",
                  fontWeight: "bold",
                  label:
                    totalCount === 0 && appType === "Backup"
                      ? "No Backups Found "
                      : totalCount === 0 && appType === "Restore"
                      ? "No Restores Found "
                      : totalPercentage,
                  formatter: function (w) {
                    return totalCount === 0 ? "" : "Successful";
                  },
                },
              },
            },
          },
        },
      });
    }
  }, [jobSummary, totalCount, totalPercentage, status]);

  return (
    <div className={styles.container}>
      {isLoading && !errorMessage ? (
        <div className={styles.spinner}>
          <Spinner size="large" />
        </div>
      ) : (
        <Chart options={options} series={series} type="donut" height={370} />
      )}
    </div>
  );
};

export default memo(JobSummary);
